import { render } from "./new_measurement_print.vue?vue&type=template&id=08327d5c&scoped=true"
import script from "./new_measurement_print.vue?vue&type=script&lang=js"
export * from "./new_measurement_print.vue?vue&type=script&lang=js"

import "./new_measurement_print.vue?vue&type=style&index=0&id=08327d5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08327d5c"]])

export default __exports__